import { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaXmark } from "react-icons/fa6";
import { MdOutlinePassword } from "react-icons/md";
import { userServices } from "../../../APIServices/UserData/userServices";
import Swal from "sweetalert2";
import { authServices } from "../../../APIServices/UserData/authServices";

const UpdatePassword = ({auth}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [loader, setLoader] = useState("");

  const changePassword = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Change Password?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.currentPassword = currentPassword;
        userData.newPassword = newPassword;
        userData.repeatPassword = repeatPassword;
        let data = await userServices.changePassword(auth, userData);
        if (data?.statusCode === 200) {
          setCurrentPassword("");
          setNewPassword("");
          setRepeatPassword("");
          await authServices.logout(auth);
        }
        setLoader(false);
      }
    });
  };
  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3">
        <h5 className="fw-bold mb-1">Change Password</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Form.Group className="mb-2">
                <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                  Current Password
                </Form.Label>
                <Form.Control
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  type="password"
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  placeholder="Enter Current Password"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                  New Password
                </Form.Label>
                <Form.Control
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  type="password"
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  placeholder="Enter New Password"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                  Confirm New Password
                </Form.Label>
                <Form.Control
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                  type="password"
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  placeholder="Enter Confirm New Password"
                />
              </Form.Group>
              <div className="hstack justify-content-end">
                <Button
                  disabled={
                    loader ||
                    !currentPassword ||
                    !newPassword ||
                    !repeatPassword
                  }
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Change Password"
                  onClick={changePassword}
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <MdOutlinePassword /> Change Password
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UpdatePassword;
